var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      attrs: {
        color: _vm.color,
        timeout: _vm.closeable ? -1 : _vm.timeout || 5000,
        width: "700px"
      },
      on: { close: _vm.close },
      model: {
        value: _vm.value,
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    },
    [
      _c(
        "div",
        [
          _vm.closeable
            ? _c(
                "v-btn",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "1px",
                    right: "1px"
                  },
                  attrs: { "x-small": "", text: "", fab: "" },
                  on: { click: _vm.close }
                },
                [_vm._v("\n      x\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mr-3" }, [_vm._v(_vm._s(_vm.message))]),
          _vm._v(" "),
          _vm.more
            ? _c(
                "v-btn",
                {
                  staticClass: "mx-auto",
                  attrs: { "x-small": "", light: "" },
                  on: {
                    click: function($event) {
                      _vm.openMore = !_vm.openMore
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.openMore ? "Voir moins" : "Voir plus") +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.more && _vm.openMore
            ? _c(
                "v-card",
                {
                  staticClass: "grey--text mt-2 px-1",
                  staticStyle: { overflow: "auto" },
                  attrs: {
                    elevation: "0",
                    color: "#f2f2f2",
                    width: "640px",
                    "max-height": "20vh"
                  }
                },
                _vm._l(_vm.more, function(item, index) {
                  return _c("div", { key: index }, [
                    _c("span", { staticClass: "font-italic" }, [
                      _vm._v(_vm._s(item.url))
                    ]),
                    _vm._v("\n        : " + _vm._s(item.error) + "\n      ")
                  ])
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }